module.exports = "/_next/static/images/up-line-9acabc196060c406f6ec5b0920faf19c.svg";